import { useMutation } from '@tanstack/react-query'
import { calculateTaxCBPG } from '@/modules/hs/api/hs-tax.api'
import {
  HsTaxCBPGCalculatorRequest,
  HsTaxCBPGCalculatorResponse,
} from '@/modules/hs/types/hs-tax.response'

/**
 * Custom hook để tính thuế CBPG
 *
 * Logic:
 * 1. Không có Form C/O → Max1 (thuế cao nhất từ bất kỳ nước nào)
 * 2. Có Form C/O:
 *    - Nước không bị thuế CBPG → 0 (MIN)
 *    - Nước bị thuế CBPG:
 *      + Không có chứng nhận công ty → Max2 (thuế cao nhất theo nước đó)
 *      + Có chứng nhận công ty → tax_rate của công ty đó
 */
export const useCalculateTaxCBPG = () => {
  return useMutation<
    HsTaxCBPGCalculatorResponse,
    Error,
    HsTaxCBPGCalculatorRequest
  >({
    mutationFn: (data: HsTaxCBPGCalculatorRequest) => calculateTaxCBPG(data),
    retry: 1,
  })
}
